export const az = {
  title: 'Tərəfdaşlar',
};
export const en = {
  title: 'Partners',
};
export const ru = {
  title: 'Партнеры',
};
